import React from 'react'
import { Col, Input, Row, Form, Tooltip, Checkbox, DatePicker, Typography, Divider, Alert,Upload,Space, Switch, Radio, Button, Mentions, Collapse, Cascader } from 'antd';
import { BASE_MARGIN } from 'constants/Layout';
import SelectWithOtherOption from 'components/SelectWithOtherOption';
import { DeleteIcon, HelpSolidIcon } from 'components/Icons';
import _, { isBoolean, isUndefined, trim } from 'lodash';
import SelectWithActionButton from 'components/SelectWithActionButton';
import SelectWithCustomValue from 'components/SelectWithCustomValue';
import SelectWithPaginatedData from 'components/SelectWithPaginatedData';
import CustomSelect from 'components/CustomSelect';
import CustomDuration from 'components/CustomDuration';
import { CloudUploadOutlined, PlusOutlined } from '@ant-design/icons'
import InputWithPlaceholder from 'components/InputWithPlaceholder';
import { hasPermission } from './authService';
import classNames from 'classnames';
import SwitchWithLabel from 'components/SwitchWithLabel';
import SelectWithUserEmail from 'components/SelectWithUserEmail';
import ProductOrSubProductSelectWithAddButton from 'components/ProductOrSubProductSelectWithAddButton';
import { disableFutureDates } from 'components/ColumnFilterDateRange';
import PasswordInputWithEyes from 'components/PasswordInputWithEyes';
import moment from 'moment';
import CronConfig from 'components/CronConfig';
import { getInnerText } from 'components/Vocabulary';
import ProjectSelectWithAddButton from 'components/ProjectSelectWithAddButton';
import { CVSSVectorGenerator } from 'views/Findings/ManualFindingsCVSSFields';
import DurationPickerField from 'components/DurationPickerField';
import TransferComponent from '../components/TransferComponent';
import DayPicker from 'components/DayPicker';
import TimePicker from 'components/TimePicker';
import ProjectSelectWithAddButtonV2 from 'components/ProjectSelectWithAddButtonV2';
import ExceptionSelectWithAddButton from 'components/ExceptionSelectWithAddButton';
import ACDurationPicker from 'ac-components/ACDurationPicker';
import AssessmentSelectWithAddButton from 'components/AssessmentSelectWithAddButton';
import { EMAIL_REGEX, hexCode3, hexCode6, ip6Re, ip6ReMaskCompulsory, ipRe, ipReMaskCompulsory } from 'constants/RegExp';

const {Text, Title} = Typography;
const {Dragger} = Upload
export function generateFormFields(fields, colSpan = 24, listField, index=1){
    return (
        <Row key={index} gutter={[BASE_MARGIN * (listField ? 1 : 4), 0]}>
            {
                fields.map((field, i) => getField(field, i, colSpan, listField))
            }
        </Row>
    )
}

export function getField(field, i, colSpan = 24, listField) {
    let customProps = {};
    let _colSpan = field.colSpan || colSpan;
    if(field.type === FieldTypes.HEADING){
        _colSpan = 24;
    }
    const noStyle = isBoolean(field.noStyle) ? field.noStyle : ([FieldTypes.HEADING, FieldTypes.DIVIDER].includes(field.type) || (field.render && !field.label));
    const label = getHelpLabel(field);
    const isBooleanField = [FieldTypes.BOOLEAN, FieldTypes.SWITCH].includes(field.type);
    let { rules = [] } = field;
    if(field.required){
        rules = [{
            required: true,
            message: <>{field.label} is required.</>
        }, ...rules];
    }
    if(field.type === FieldTypes.TAGS  && !field.NoDefaultLengthRule){
        rules = [TAG_LENGTH_RULE, ...rules];
    } else if(!field.type && !field.render && !field.NoDefaultLengthRule){
        // Input text
        rules = [INPUT_TEXT_LENGTH_RULE, ...rules];
    } else if(field.type === FieldTypes.TEXT_AREA  && !field.NoDefaultLengthRule){
        rules = [ field.customLengthRule || TEXT_AREA_LENGTH_RULE, ...rules]
    }
    if (field.props?.setFormListItemProps) {
        customProps = field.props.setFormListItemProps(field, listField);
    }
    // Remove white space from all input and textarea fields
    if ((field.type === FieldTypes.TEXT_AREA || field.type === FieldTypes.MENTIONS || _.isUndefined(field.type)) && !field.render) {
        customProps.normalize = normalizeValue
    }
    return (
        <Col span={_colSpan} key={field.key || `${field.type}.${field.name}.${i}`} style={field.style}>
            {
                field.type === FieldTypes.GROUP
                ?
                <Alert message={field.label} description={generateFormFields(field.fields, _colSpan)} />
                :
                // field.type === FieldTypes.GROUP
                // ?
                // getInputField(field)
                // :
                <Form.Item
                    {...listField}
                    name={listField ? [listField?.name, field.name] : field.name}
                    label={(isBooleanField && field.inline) ? "" : label}
                    rules={rules}
                    valuePropName={field.valuePropName || (isBooleanField ? "checked" : "value")}
                    noStyle={noStyle}
                    className={field.className}
                    labelAlign={field.labelAlign}
                    extra={field.extra}
                    hasFeedback={field.hasFeedback}
                    validateStatus={field.validateStatus}
                    labelCol={field.labelCol}
                    wrapperCol={field.wrapperCol}
                    {...customProps}
                >
                    {
                        field.permission && !hasPermission(field.permission)
                        ?
                        <FormItemNoAccessToolTip>
                            {getInputField(field, true, listField)}
                        </FormItemNoAccessToolTip>
                        :
                        getInputField(field, false, listField)
                    }
                </Form.Item>
            }
        </Col>
    )
}

function FormItemNoAccessToolTip({ children, ...props }) {
    return (
        <Tooltip title={"No access"}>
            <div className="d-inline w-100">
                {React.cloneElement(children, {
                    ...props
                })}
            </div>
        </Tooltip>
    )
}

function normalizeValue(val) {
    const value = val.trim();
    if (value !== '') {
        return val
    }
    return value
}

function getHelpLabel(field){
    if(field.help){
        const { help, toolTipPlacement = 'top', toolTipStyle={} } = field;
        return (
            <>
                {field.label}
                &nbsp;
                <Tooltip title={help} placement={toolTipPlacement} {...toolTipStyle}>
                    <HelpSolidIcon />
                </Tooltip>
            </>
        )
    }
    return field.label;
}

const INPUT_TEXT_LENGTH_RULE = {
    max: 254,
    message: "Maximum length is 255 characters" 
}

const TEXT_AREA_LENGTH_RULE = {
    max: 499,
    message: "Maximum length is 500 characters" 
}

const TAG_LENGTH_RULE = () => {
    return {
        validator: TAG_LENGTH_VALIDATOR
    }
}

const TAG_LENGTH_VALIDATOR = (_, values) => {
    if (values?.length) {
        for (const value of values) {
            if (value && value.length > 256) {
                return Promise.reject("Maximum length is 256 characters.");
            }
        }
    }
    return Promise.resolve();
}

export const filterVocabularyOption = (input, option) => {
    let { label } = option;
    const { filterLabel } = option;
    if (!label && !filterLabel) return true;
    if(!_.isString(label)){
        label = filterLabel ? filterLabel : getInnerText(label)
    }
    return label.toLowerCase().indexOf(input.toLowerCase()) >= 0
}

export function getInputField(field, disabled = false, listField){
    const placeholder = field.props?.defaultValue || field.placeholder || field.label || field.name;
    const { setExtraProps, showSearch = true , ...fieldProps } = field.props || {};
    
    const props = {
        placeholder,
        disabled: field.disabled || disabled,
        loading: field.loading,
        name: field.name,
        autoFocus: field.autoFocus,
        ...fieldProps,
    }
    if (setExtraProps && !_.isEmpty(listField)) {
        Object.assign(props, setExtraProps(field, listField));
    }
    if(field.render){
        return field.render({...field, ...props, ...listField});
    }
    switch(field.type){
        case FieldTypes.MULTI_SELECT:
        case FieldTypes.SELECT:
        case FieldTypes.SELECT_OTHER:
        case FieldTypes.TAGS:
        case FieldTypes.SELECT_WITH_ACTION:
        case FieldTypes.SELECT_WITH_CUSTOM:
        case FieldTypes.SELECT_WITH_PAGINATED_DATA:
        case FieldTypes.USER_EMAIL:
        case FieldTypes.PROD_SUBPROD_SELECT_ADD:
        case FieldTypes.PROJECT_SELECT_ADD:
        case FieldTypes.PROJECT_SELECT_ADD_V2:
        case FieldTypes.EXCEPTION_SELECT_ADD:
        case FieldTypes.ASSESSMENT_SELECT_ADD:
            { props.propsGenerator = field.propsGenerator;
            props.notFoundContent = field.notFoundContent;
            props.listField = listField;
            props.options = props.options ? parseSelectOptions(props.options):parseSelectOptions(field.options);
            props.onSearch = field.onSearch;
            props.showSearch = showSearch;
            props.optionFilterProp = props.optionFilterProp || "label";
            if(_.isString(field.label) && field.label.toLowerCase().includes("environment")){        //A hack, in order to handle (vocabulary) environment selection in general rather than doing same in multiple places.
                props.filterOption = filterVocabularyOption;
            };
            let Component = CustomSelect;
            if(field.type === FieldTypes.MULTI_SELECT){
                props.mode = "multiple";
            } else if(field.type === FieldTypes.TAGS){
                props.mode = "tags";
            } else if(field.type === FieldTypes.SELECT_OTHER){
                Component = SelectWithOtherOption;
            } else if(field.type === FieldTypes.SELECT_WITH_CUSTOM){
                Component = SelectWithCustomValue;
                props.btnType = field.btnType;
                props.btnText = field.btnText;
                props.onActionClick = field.onActionClick;
            } else if(field.type === FieldTypes.SELECT_WITH_PAGINATED_DATA){
                Component = SelectWithPaginatedData;
            } else if (field.type === FieldTypes.USER_EMAIL) {
                Component = SelectWithUserEmail;
            } else if (field.type === FieldTypes.PROD_SUBPROD_SELECT_ADD) {
                Component = ProductOrSubProductSelectWithAddButton;
            } else if (field.type === FieldTypes.PROJECT_SELECT_ADD) {
                Component = ProjectSelectWithAddButton;
            } else if (field.type === FieldTypes.PROJECT_SELECT_ADD_V2) {
                Component = ProjectSelectWithAddButtonV2;
            } else if (field.type === FieldTypes.EXCEPTION_SELECT_ADD) {
                Component = ExceptionSelectWithAddButton;
            } else if (field.type === FieldTypes.ASSESSMENT_SELECT_ADD) {
                Component = AssessmentSelectWithAddButton;
            }
            
            else {
                if(field.type === FieldTypes.SELECT_WITH_ACTION){
                    Component = SelectWithActionButton;
                    props.btnType = field.btnType;
                    props.btnText = field.btnText;
                    props.disablebtn = field.disablebtn
                    props.onActionClick = field.onActionClick;
                }
            }
            return (
                <Component {...props} />
            ); }

        case FieldTypes.CASCADE_SELECT:
            return <Cascader options={parseSelectOptions(field.options)} {...props} />

        case FieldTypes.TEXT_AREA:
            return <Input.TextArea {...props} />
        case FieldTypes.NUMBER:
            return <InputWithPlaceholder type="number" {...props} min={field.min} max={field.max} />
        case FieldTypes.BOOLEAN:
            props.listField = listField;
            if(field.inline){
                const label = getHelpLabel(field);
                return <Checkbox {...props}><span className="text-bold">{label}</span></Checkbox>
            }
            return <Checkbox {...props} />
        case FieldTypes.RADIO:
            return <Radio.Group {...props}>
                {field.options.map((entry) => {
                    const hasAccess = !_.isUndefined(entry.permission) ? hasPermission(entry.permission) : true;
                    const Item = props.itemTypeButton ? Radio.Button : Radio;
                    const radio = <Item className={props.radioClassname} key={entry.value} value={entry.value} disabled={!hasAccess || entry.disabled}>{entry.label}</Item>
                    return hasAccess ? radio : <Tooltip title="No Access">{radio}</Tooltip>;
                })}
            </Radio.Group>
        case FieldTypes.SWITCH:
            // Set default value of switch to "small"
            if(field.inline){
                // return <><span className="text-bold m-r-sm">{field.label}</span><Switch {...props} size={props?.size ?? "small"} /></>
                return <SwitchWithLabel {...props} size="small" label={getHelpLabel(field)} />;
            }
            return <Switch {...props} size={props?.size ?? "small"} />
        case FieldTypes.DATE:
            return <DatePicker {...props} />
        case FieldTypes.DATE_RANGE:
            return <DatePicker.RangePicker disabledDate={disableFutureDates} {...field.props} />
        case FieldTypes.DATE_RANGE_CUSTOM:
            return <DurationPickerField allowFutureDates={props?.allowFutureDates}/>
        case FieldTypes.AC_DATE_RANGE_CUSTOM:
            return <ACDurationPicker {...field.props} />;
        case FieldTypes.LABEL:
            return <Text>{field.value}</Text>
        case FieldTypes.HEADING:
            return <Title level={5}>{field.value}</Title>
        case FieldTypes.PASSWORD:
            {
                const { placeholder = "**************", ...restProps } = props;
                return <PasswordInputWithEyes {...restProps} placeholder={placeholder} />
            }
        case FieldTypes.DIVIDER:
            return <Divider className="m-y-xs" />
        case FieldTypes.ATTACHMENT:
            return (
                <Dragger {...field.uploadProps}>
                   <Space>
                    <p className="ant-upload-text"><CloudUploadOutlined className="ant-upload-drag-icon"/> {field.uploadProps.placeholder || "Drop your files or click to upload from here"}</p>
                   </Space> 
                </Dragger>
            )
        case FieldTypes.CHECKBOX_GROUP:
            { const options = parseSelectOptions(field.options);
            const disabledAll = field.permission ? !hasPermission(field.permission) : false;
            const onChange = field.props?.onChange
            return (
                <Checkbox.Group options={options} defaultValue={field.defaultValue} disabled={disabledAll} onChange={onChange}/>
            ) }
        case FieldTypes.LIST:
            { const minimumRow = props.minimumRow ?? 1;
            let formListField =  (
                <Form.List name={_.isFunction(field.name) ? field.name(listField) : field.name}>
                    {(fields, { add, remove }) => (
                        <>
                            {fields.map((currentRowField) => {
                                let rowDisabled = false;
                                return <Alert
                                    className={classNames("m-b-sm p-b-0 c ", field.listClass)}
                                    key={currentRowField.key} 
                                    type="info"
                                    description={<>
                                        {field.fieldRows.map((entry, index) => {
                                            if (entry[0]?.props?.setExtraProps) {
                                                rowDisabled = (entry[0].props.setExtraProps(field, currentRowField) || {}).disabled || false;
                                            }
                                            return generateFormFields(entry, 24, currentRowField, index)
                                        })}
                                        {!field.editMode &&
                                        <Tooltip title={ field.deleteIconTooltip  || "Delete Row"} placement="top">
                                             <DeleteIcon className={classNames('list-item-delete-btn', { disabled: fields.length <= minimumRow || rowDisabled }, 'danger')}
                                             onClick={() => {
                                                 if(!(fields.length <= minimumRow) && !rowDisabled) {
                                                    remove(currentRowField.name);
                                                    field.onRemoveItem && field.onRemoveItem(currentRowField);
                                                 }
                                                }} />
                                        </Tooltip>
                                        }
                                    </>}
                                />
                            })}
                            {!field.editMode && <Row className="m-b-0">
                                <Col span={18} />
                                <Col span={6} className="p-l-xs p-r-xs">
                                    {/* <Form.Item> */}
                                        <Button type="dashed" onClick={() => add(field.newRowDefaultValue)} icon={<PlusOutlined />} disabled={field.addButtonDisabled}>
                                            {props.displayIcon ? "" : field.buttonLabel || "Add Mapping"}
                                        </Button>
                                    {/* </Form.Item> */}
                                </Col>
                            </Row>}
                        </>
                    )}
                </Form.List>
            )
            if (field.collapse) {
                formListField =  (
                    <Collapse defaultActiveKey={field.name} bordered={false} className={`m-b-sm ${field.collapseClass}`} onChange={field.collapseOnChange}>
                        <Collapse.Panel header={<Text strong>{field.collapseTitle}</Text>} key={field.name} className="no-border">
                            { formListField }
                        </Collapse.Panel>
                    </Collapse>
                );
            }
            return formListField; }
        case FieldTypes.ANTD_DEFAULT_INPUT:
            return <Input {...props}/>;
        case FieldTypes.CUSTOM_DURATION:
            return <CustomDuration {...props}/>;
        case FieldTypes.MENTIONS:
            return <Mentions {...props}>
                {
                    props.options.map((entry) => {
                        return <Mentions.Option key={entry} value={entry}>{entry}</Mentions.Option>
                    })
                }
            </Mentions>;
        case FieldTypes.CRON_CONFIG:
            return <CronConfig {...props}/>;
        case FieldTypes.DAYS:
            return <DayPicker {...props} />;
        case FieldTypes.HOUR:
            return <TimePicker {...props} />;
        case FieldTypes.CVSS_VECTOR:
            return <CVSSVectorGenerator {...props}/>;
        case FieldTypes.BUTTON:
            return <Button {...props}>{field.label}</Button>;
        case FieldTypes.INLINE_GROUP:
            return <Input.Group compact>
                {field.fields.map((field) => {
                    const isBooleanField = [FieldTypes.BOOLEAN, FieldTypes.SWITCH].includes(field.type);
                    const noStyle = isBoolean(field.noStyle) ? field.noStyle : ([FieldTypes.HEADING, FieldTypes.DIVIDER].includes(field.type) || (field.render && !field.label));
                    const isButton = field.type === FieldTypes.BUTTON;
                    return isButton ?
                    getInputField(field) :
                    <Form.Item
                        {...listField}
                        name={listField ? [listField?.name, field.name] : field.name}
                        label={(isBooleanField && field.inline) ? "" : field.label}
                        rules={field.rules}
                        valuePropName={isBooleanField ? "checked" : "value"}
                        noStyle={noStyle}
                        className={field.className}
                        labelAlign={field.labelAlign}
                        extra={field.extra}
                        hasFeedback={field.hasFeedback}
                        validateStatus={field.validateStatus}
                        labelCol={field.labelCol}
                        wrapperCol={field.wrapperCol}
                        style={field.style}
                    >
                        {getInputField(field)}
                    </Form.Item>
                })}
            </Input.Group>
        case FieldTypes.TRANSFER:
            return <TransferComponent {...props}/>
        default:
            return <InputWithPlaceholder {...props} />
    }
}

export function parseSelectOptions(options){
    // No need to parse if options are already in correct format.
    if(_.size(options) > 0){
        const index = Math.floor(options.length / 2);
        if(_.has(options[index], "label") && _.has(options[index], "value")){
            return options;
        }
    }
    return _.map(options, (option) => {
        // eslint-disable-next-line prefer-const
        let { label = option, value = option , children, ...props} = option;
        children = _.isArray(children) ? parseSelectOptions(children) : undefined;
        if(_.isObject(value) && !_.isString(option)){
            label = option.name || option.displayName || option.teamName; // displayName is for user list and name for others.
            value = option.id; 
            return { label, value, children,  ...props };
        } else {
            return { label, value, children };
        }
    })
}

export const FieldTypes = {
    LABEL: 'Label',
    PASSWORD: 'password',
    BOOLEAN: "Boolean",
    CHECKBOX_GROUP: "CHECKBOX_GROUP",
    SWITCH: "SWITCH",
    DATE_RANGE: "DateRange",
    DATE: "Date",
    NUMBER: "Number",
    TEXT_AREA: "TextArea",
    MULTI_SELECT: "MultiSelect",
    SELECT_OTHER: "SelectOther",
    SELECT_WITH_CUSTOM: "SelectWithOther",
    TAGS: "Tags",
    SELECT: "Select",
    CASCADE_SELECT: "cadcade_select",
    SELECT_WITH_ACTION: "SelectWithAction",
    HEADING: "Heading",
    DIVIDER: "Divider",
    GROUP: "GROUP",
    ATTACHMENT:"ATTACHMENT",
    RADIO:"RADIO",
    LIST:"LIST",
    SELECT_WITH_PAGINATED_DATA:"SelectWithPaginatedData",
    ANTD_DEFAULT_INPUT: 'AntdInput',
    MENTIONS: 'MENTIONS',
    USER_EMAIL: 'USER_EMAIL',
    PROD_SUBPROD_SELECT_ADD: 'PROD_SUBPROD_SELECT_ADD',
    PROJECT_SELECT_ADD: 'PROJECT_SELECT_ADD',
    PROJECT_SELECT_ADD_V2: 'PROJECT_SELECT_ADD_V2',
    EXCEPTION_SELECT_ADD: 'EXCEPTION_SELECT_ADD',
    ASSESSMENT_SELECT_ADD: 'ASSESSMENT_SELECT_ADD',
    CUSTOM_DURATION: 'CUSTOM_DURATION',
    CRON_CONFIG: 'CRON_CONFIG',
    CVSS_VECTOR: 'CVSS_VECTOR',
    DATE_RANGE_CUSTOM: 'DATE_RANGE_CUSTOM',
    AC_DATE_RANGE_CUSTOM: 'AC_DATE_RANGE_CUSTOM',
    INLINE_GROUP: 'INLINE_GROUP',
    BUTTON: 'BUTTON',
    TRANSFER: 'TRANSFER',
    HOUR: 'HOUR',
    DAYS: 'DAYS',
}

export const CUSTOM_FIELD_TYPE = {
    "select": FieldTypes.SELECT_WITH_CUSTOM,
    "multiselect": FieldTypes.MULTI_SELECT,
    "priority": FieldTypes.SELECT_WITH_CUSTOM,
    "cascadingselect": FieldTypes.CASCADE_SELECT,
    "array":FieldTypes.SELECT_WITH_PAGINATED_DATA,
    "multiuserpicker":FieldTypes.SELECT_WITH_PAGINATED_DATA,
    "textarea": FieldTypes.TEXT_AREA,
    "html": FieldTypes.TEXT_AREA,
    "userpicker": FieldTypes.SELECT_WITH_PAGINATED_DATA,
    "multicheckboxes":FieldTypes.CHECKBOX_GROUP,
    "boolean": FieldTypes.BOOLEAN,
    // "float":FieldTypes.NUMBER, 
    "integer": FieldTypes.NUMBER,
    // "double": FieldTypes.NUMBER,
    "service-entity-field-cftype":FieldTypes.SELECT_WITH_PAGINATED_DATA,
    "gh-epic-link": FieldTypes.SELECT_WITH_PAGINATED_DATA,
    // removing gh-sprint as it is not working on backend
    // "gh-sprint":FieldTypes.SELECT,
    "datetime":FieldTypes.DATE,
    "datepicker": FieldTypes.DATE,
    "rm-teams-custom-field-team": FieldTypes.SELECT_WITH_PAGINATED_DATA,
    "atlassian-team": FieldTypes.SELECT_WITH_PAGINATED_DATA,
    "radiobuttons": FieldTypes.RADIO,
    "labels": FieldTypes.TAGS,
    "glide_date_time": FieldTypes.DATE,
    "glide_date": FieldTypes.DATE,
    "calendar_date_time": FieldTypes.DATE,
    "due_date": FieldTypes.DATE,
    "accounts.customfield": FieldTypes.SELECT_WITH_PAGINATED_DATA,
    "group": FieldTypes.SELECT_WITH_PAGINATED_DATA,
    "assignee": FieldTypes.SELECT_WITH_PAGINATED_DATA,
    "lookup": FieldTypes.SELECT_WITH_PAGINATED_DATA,
    "tagger": FieldTypes.SELECT_WITH_CUSTOM,
    "requester": FieldTypes.SELECT_WITH_PAGINATED_DATA,
    "followers": FieldTypes.SELECT_WITH_PAGINATED_DATA,
    "decimal": FieldTypes.NUMBER,
    "date": FieldTypes.DATE,
    "checkbox": FieldTypes.BOOLEAN,
    "version": FieldTypes.SELECT_WITH_CUSTOM, 
    "multiversion": FieldTypes.MULTI_SELECT,
    "enum": FieldTypes.SELECT_WITH_CUSTOM,
    "multi_enum": FieldTypes.MULTI_SELECT,
    "people": FieldTypes.SELECT_WITH_PAGINATED_DATA,
    // Archer ticket system supported custom fields
    "4": FieldTypes.SELECT_WITH_PAGINATED_DATA,
    "8": FieldTypes.SELECT_WITH_PAGINATED_DATA,
    "2": FieldTypes.NUMBER,
    "3": FieldTypes.DATE,
    "duedate": FieldTypes.DATE,
    "cmdb-object-cftype": FieldTypes.SELECT_WITH_PAGINATED_DATA,
    "singlecftype": FieldTypes.SELECT_WITH_CUSTOM,
    "multicftype": FieldTypes.MULTI_SELECT
}

export const ALL_DATE_FIELDS = ["glide_date_time", "calendar_date_time", "glide_date", "datetime", "datepicker", "due_date", "date", "3", "duedate"];
export const TIME_SUPPORTED_DATE_FIELDS = ["glide_date_time", "calendar_date_time"];
export const FIELDS_WITH_OPTIONS = ["multiselect", "select","multicheckboxes","array","multiuserpicker", "radiobuttons", "cascadingselect", "priority", "tagger", "multiversion", "version", "enum", "multi_enum"];
export const CUSTOM_FIELDS_WITH_OPTIONS = ["multiselect", "select","array", "multicheckboxes", "radiobuttons", "cascadingselect", "priority", "tagger", "multiversion", "version", "enum", "multi_enum", "singlecftype", "multicftype"];
export const CUSTOM_FIELDS_WITH_USER_API = ["multiuserpicker","userpicker"];
export const CUSTOM_FIELDS_WITH_SEARCH = ["service-entity-field-cftype", "rm-teams-custom-field-team", "atlassian-team", "array", "gh-epic-link", "labels", "reference", "accounts.customfield", "group", "lookup", "assignee", "requester", "followers", "people", "8", "4", "cmdb-object-cftype"];
export const CUSTOM_FIELDS_SINGLE_SELECTION = ["rm-teams-custom-field-team", "atlassian-team", "gh-epic-link", "reference", "accounts.customfield", "group", "assignee", "lookup", "requester", "enum", "8", "4"];
export const PROVIDE_SELECTED_VALUES = ["multi_enum", "enum"];

export const getCustomFieldValue = (type,value) => {
    switch(type){
        case "datetime":
        case "dateTime":
        case "datepicker":
        case "glide_date_time":
        case "calendar_date_time":
        case "glide_date":
        case "due_date":
        case "date":
        case "3":
        case "duedate":            
            return  _.isEmpty(value) || !moment(value).isValid() ? value : moment(value);
        case "array":
        case "multiuserpicker":
        case "multiselect":
        case "multiversion":
        case "labels":
        case "followers":
        case "people":
        case "multi_enum":
        case "cmdb-object-cftype":    
        case "multicftype":
            return  _.isEmpty(value) ? [] : value.split(',');
        case "cascadingselect":
            return  _.isEmpty(value) ? [] : value.split(':');
        default:
            return value;
    }
}

export function policyNameRegexValidator({
    regex = /^[A-Za-z]+[.A-Za-z0-9 &_-]*/g, message = "Alphanumeric with space, hyphen, underscore, ampersand, period are allowed."
}){
    return {
        validator: (rule, value) => {
            if(value.length >= 1){
                if(!/^[a-zA-Z]{1}/.test(value)) {
                    return Promise.reject("Policy name should start with alphabet.");
                }
                const remains = value.split(regex).filter(Boolean).length;
                if(remains > 0){
                    return Promise.reject(message);
                }
                if(value.trim().length < 3 || value.trim().length > 50){
                    return Promise.reject("Policy name should be of size 3-50.");
                }
            }
            return Promise.resolve();
        },
    }
}

export const NAME_REGEX = /^[&A-Za-z]+[.A-Za-z0-9 _&-]*/g;
export const NAME_REGEX_START_WITH_NUMBER = /(?!^[\d _&\\-]+$)^[.A-Za-z0-9]+[.A-Za-z0-9 ()&_/\\-]*$/g;

export function nameRegexValidator({
    regex = NAME_REGEX, message = "Alphanumeric with space, underscore, hyphen, ampersand and period are allowed.", min = 2, max=100,
fieldName= "Name"}){
    //covers blankSpace validation too
    return {
        validator: (rule, value) => {
            if(value){
                if(regex){
                    const remains = value.split(regex).filter(Boolean).length;
                    if(remains > 0){
                        return Promise.reject(message);
                    }
                }
                if((value.trim().length < min || value.trim().length > max)){
                    return Promise.reject(`${fieldName} should be of size ${min}-${max}.`);
                }
            }
            return Promise.resolve();
        },
    }
}

export function controlIdRegexValidator({
    regex = /^[A-Za-z]+[A-Za-z0-9 _-]*/g, message = "Alphanumeric with space, hyphen and underscore are allowed."
}){
    return {
        validator: (_, value) => {
            if(value){
                if(!isNaN(parseInt(value))){
                    return Promise.reject("Control ID should start with alphabet.");
                }
                const remains = value.split(regex).filter(Boolean).length;
                if(remains > 0){
                    return Promise.reject(message);
                }
                if(value.length > 128){
                    return Promise.reject(`Control ID should be of max size 128.`);
                }
            }
            return Promise.resolve();
        },
    }
}

export function checkCharLimit(charLimit = 250) {
    return {
        validator: (_, value) => {
            if (typeof value === 'string' && value.trim().length > charLimit) {
                return Promise.reject(`Maximum length is ${charLimit} characters`);
            } else {
                return Promise.resolve();
            }
        }
    }
}

export function checkNumberLimit({ min, max }) {
    return {
      validator: (record, value) => {
        value = trim(value);
        if (value) {
          value = Number(value);
          let errorText;
          if (!isUndefined(min) && value < min) {
            errorText = `Minimum limit is ${min}`;
          } else if (!_.isUndefined(max) && value > max) {
            errorText = `Maximum limit is ${max}`;
          }
          if (errorText) {
            return Promise.reject(errorText);
          }
        }
        return Promise.resolve();
      },
    };
}

export function hexCodeRegexValidator() {
    return {
        validator: (_rule, value) => {
            if (!_.isEmpty(value) && (value.length > 7 || value.length < 4)) {
                return Promise.reject(new Error('code should be 3 or 6 length'));
            }

            if (!_.isEmpty(value) && !hexCode3.test(value) && !hexCode6.test(value)) {
                return Promise.reject(new Error('Not a valid hexCode.'))
            } else {
                return Promise.resolve();
            }
        }
    }
}

export function urlRegexValidator() {
    return {
        validator: (_rule, value) => {
            // Allow URL and IP, with or without (protocol/port/query params).
            // eslint-disable-next-line
            const urlRe = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.\_\/]{1}([a-z0-9])+)*([a-z0-9-]{1,256})(:[0-9]{1,5})?(\/[a-zA-Z0-9-%_.#: ]*)*(\?[a-zA-Z0-9=%&._\[\]+~,:-{}()]*)?(\#[a-zA-Z0-9_-]+)?$/i;

            if (!_.isEmpty(value) && value.endsWith('/')) {
                return Promise.reject(new Error('URL should not end with /.'));
            }

            if (!_.isEmpty(value) && !urlRe.test(value) && !ipRe.test(value) && !ip6Re.test(value)) {
                return Promise.reject(new Error('Not a valid URL/IP.'))
            } else {
                return Promise.resolve();
            }
        }
    }
}

export function ipRegexValidator() {
    return {
        validator: (_rule, value) => {
            if (!_.isEmpty(value) && value.endsWith('/')) {
                return Promise.reject(new Error('IP should not end with /.'));
            }

            if (!_.isEmpty(value) && !ipRe.test(value) && !ip6Re.test(value)) {
                return Promise.reject(new Error('Not a valid IP.'))
            } else {
                return Promise.resolve();
            }
        }
    }
}

export function multiUrlValidator(){
    return {
        validator: (rule, values) => {
            const validator = urlRegexValidator().validator;
            Promise.all(_.map(values, v => validator(rule, v))).then(console.log).catch(console.log)
            return Promise.all(_.map(values, v => validator(rule, v)));
        }
    }
}

export const checkHttpElsePrefixLink = (link) => _.startsWith(link, "http") ? link : "//"+link;

export function domainRegexValidator() {
    return {
        validator: (_rule, value) => {
            // eslint-disable-next-line
            let urlRe = /^[a-zA-Z0-9-]{0,62}[a-zA-Z0-9](\.[a-zA-Z]{2,})+$/;

            if (!_.isEmpty(value) && value.endsWith('/')) {
                return Promise.reject(new Error('Domain should not end with /.'));
            }

            if (!_.isEmpty(value) && !urlRe.test(value)) {
                return Promise.reject(new Error('Not a valid domain.'))
            } 
            if (!_.isEmpty(value) && ["gmail.com"].indexOf(value) !== -1) {
                return Promise.reject(new Error('gmail.com is a restricted email domain.'))
            }
            else {
                return Promise.resolve();
            }
        }
    }
}

export function ipValidationWithMask() {
    return {
        validator: (_rule, value) => {
            if (!_.isEmpty(value) && value.endsWith('/')) {
                return Promise.reject(new Error('IP range should not end with /.'));
            }

            if (!_.isEmpty(value) && !ipReMaskCompulsory.test(value) && !ip6ReMaskCompulsory.test(value)) {
                return Promise.reject(new Error('Not a valid IP range.'))
            } else {
                return Promise.resolve();
            }
        }
    }
}

export function urlWebhookRegexValidator() {
    return {
        validator: (_rule, value) => {
            const urlRe = /[\w\W]+webhook.office.com[\w\W]+/g ;
               
            if (!_.isEmpty(value) && !urlRe.test(value)) {
                return Promise.reject('Not a valid Webhook URL.')
            } else {
                return Promise.resolve();
            }
        }
    }
}
      
export const emailValidator = () => ({
    validator: (_rule, value) => {
        const isValidEmail = (val) => {
            return EMAIL_REGEX.test(val);
        }
        if(!_.isEmpty(value)) {
            if(!Array.isArray(value)){
                value = [value];
            } 
            const invalidEmailIds = value.some((_val) => (!isValidEmail(_val)));
            if(invalidEmailIds){
                return Promise.reject('Invalid Email Address');
            }
        }
        return Promise.resolve();
    }
});

export function versionValidator() {
    return {
        pattern: /^\d+(\.\d+){0,3}$/i,
        message: "Enter valid version number"
    }
}

export function directoryRegexValidator() {
    return {
        validator: (_rule, value) => {
            // eslint-disable-next-line
            let regExp = /^(\/$|((\/|[A-Z]\:\/)[a-zA-Z_0-9-. ]+(\/)?)+$)|^(\\$|((\\|[A-Z]\:\\)[a-zA-Z_0-9-. ]+(\\)?)+$)/gm
            if (!_.isEmpty(value) && !regExp.test(value)) {
                return Promise.reject(new Error('Not a valid directory.'))
            } else {
                return Promise.resolve();
            }
        }
    }
}

export function finiteNumberRegexValidator() {
    return {
        validator: (_rule, value) => {
            if(value < 0) {
                return Promise.reject(new Error('Value must be > 0'))
            } else {
                return Promise.resolve()
            }
        }
    }
}

export function CVEValidator(ignoreEmptyValue = true) {
    return {
        validator: (field, values) => {
            if (!_.isArray(values)) {
                if (values) {
                    values = [values]
                } else {
                    values = !ignoreEmptyValue ? [values] : [];
                }
            }
            if (values.length > 0) {
                const allMatch = _.every(values, (value) => {
                    if (_.isString(value)) {
                        const valueArr = value.split('-');
                        return valueArr.length === 3 && (valueArr[0] === 'CVE' || valueArr[0] === 'BDSA') && valueArr[1].length === 4 && valueArr[2].length >= 4;
                    }
                });
                if(!allMatch) {
                    return Promise.reject("CVE must be entered in the format: 'CVE-9999-9999' or 'BDSA-9999-9999'.");
                }
            }
            return Promise.resolve();
        }
    }
}

export function CWEValidator() {
    return {
        validator: (rule, values) => {
            if (!_.isArray(values)) {
                values = [values];
            }
            if(values.length > 0) {
                const allMatch = _.every(values, (value) => (!isNaN(value) && +value > 0) || _.isEmpty(value));
                if(!allMatch) {
                    return Promise.reject('Value must be greater than or equal to 1.')                                
                }
            }
            return Promise.resolve()
        },
    }
}

export function CharValidator({ min, max, applyOnEmpty = true }) {
    return {
        validator: (rule, values) => {
            if (values || applyOnEmpty) {
                const value = values.trim();
                if (min) {
                    if (value.length < min) {
                        return Promise.reject(`Value must be greater than or equal to ${min}`)
                    }
                }
                if (max) {
                    if (value.length > max) {
                        return Promise.reject(`Value must be lesser than or equal to ${max}`)
                    }
                }
            }
            return Promise.resolve()
        }
    }
}

export function editorRules({ required = true, min = 3, max = 4000, maxMessage=false, maxByteSizeInKB = 0 } = {}) {
    const contentDiv = document.createElement('div');
    return {
        validator: (rule, value) => {
            value = value || '';
            contentDiv.innerHTML = value;
            let textualContent = contentDiv.innerText;
            if (textualContent) {
                textualContent = textualContent.trim();
                if (textualContent.length < min) {
                    return Promise.reject(`Field should be atleast ${min} characters`);
                } else if (maxByteSizeInKB) {
                    textualContent = value.trim(); // Check byte size with HTML tags
                    const byteLength = new TextEncoder().encode(textualContent).byteLength;
                    if (byteLength > (maxByteSizeInKB * 1024 - 10)) {
                      return Promise.reject(maxMessage ?` Maximum allowed size is ${maxByteSizeInKB}KB`:"");
                    }
                } else if (textualContent.length > max) {
                    return Promise.reject(maxMessage?` Maximum length is ${max} characters`:"");
                }
            } else if (!textualContent && required) {
                return Promise.reject(`Please enter a proper value for this field.`);
            }
            return Promise.resolve();
        } 
    }
};

export function tagsValidator() {
    return {
        validator:(_, values) => {
            const regEx = /\s/;
            if(values){
                for(let i = 0; i < values.length; i += 1){
                    if(regEx.test(values[i].trim())){
                        return Promise.reject("The label can't contain blank spaces.");
                    }
                }
            }
            return Promise.resolve();
        }
    }
}
export function findingTagsValidator() {
    return {
        validator: (_, value) => {
            const regEx = /^\$\{finding\.tag\..+\}$/;
             
            const message = "The tag must be in the format ${finding.tag.<key>}."
            if (value) {
                    if (!regEx.test(value.trim())) {
                        return Promise.reject(message);
                    }
            }
            return Promise.resolve();
        }
    };
}


export function wholeNumberValidator() {
    return {
        validator: (_, value) => {
            if (value && !/^[1-9]\d*$/.test(value)) {
                return Promise.reject(`Input should be a whole number.`);
            }
            return Promise.resolve()
        }
    }
}